function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { DropdownMenu } from './components/DropdownMenu';
import { DropdownMenuItem } from './components/DropdownMenuItem';
import { DropdownSubMenu } from './components/DropdownSubMenu';
import { DropdownButton } from './DropdownButton';
import { DropdownLink } from './DropdownLink';
import { useDropdown } from './useDropdown';
export function Dropdown(props) {
  var children = props.children,
      extra = _objectWithoutProperties(props, ["children"]);

  return useDropdown(extra, children);
}
Dropdown.Link = DropdownLink;
Dropdown.Button = DropdownButton;
Dropdown.Menu = DropdownMenu;
Dropdown.SubMenu = DropdownSubMenu;
Dropdown.MenuItem = DropdownMenuItem;